var opShopify = Shopify || {};
const opRate = parseFloat(opShopify.currency?.rate || 1);

let fixerloop = 0;
window.opAppData = null;

function loadOpAppData() {
  try {
    const scriptTag = document.getElementById('op-app-data');
    if (!scriptTag) throw new Error("OP App Data script not found");
    window.opAppData = JSON.parse(scriptTag.textContent || '{}');
  } catch (e) {
    console.error("Failed to load OP App Data:", e);
    window.opAppData = {};
  }
}

(() => {
 loadOpAppData()
})();

const OrderProtectAppData = {};

OrderProtectAppData.SettingsManager = {
  appSettings: {},
  isInitialized: false,

  initSettings: async function (opRate, loadVariantsFlag = false) {
    try {
      if (!window.opAppData || !window.opAppData.main_settings?.length) {
        throw { status: "App Data Missing", callback: "app_data_missing" };
      }

      const settings = window.opAppData.main_settings[0];
      if (settings.Status !== "1") {
        throw { status: "App Disabled", callback: "app_disabled" };
      }

      const currentDate = settings.date;

      // Check variant existence
      const rawVariants = window.opAppData.variants || [];
      if (!Array.isArray(rawVariants) || rawVariants.length === 0) {
        throw { status: "No Variants Found", callback: "variants_missing" };
      }

      const variantData = this.loadVariantsFromObject(rawVariants, opRate);

      this.setVariants(variantData, currentDate);

      this.appSettings = {
        raw: settings,
        opRate,
        consentSettings: settings.consent_form_data?.[0] || [],
        selectors: {
          minicart_selector: settings.minicart_selector,
          subtotal_selector: settings.subtotal_selector,
          wloc_selector: settings.wloc_selector,
          swloc_selector: settings.swloc_selector,
          checkout_selector: settings.checkout_selector,
          grid_item_selector: settings.grid_item_selector,
          clicktriggers: settings.clicktriggers,
          changetriggers: settings.changetriggers,
          foreverLoad: settings.forever_load,
          getcarttriggers: settings.getcarttriggers,
        },
        integrations: {
          rechargeStatus: settings.rechargeStatus,
          rechargeArray: settings.rechargeArray,
          homeCountry: settings.homeCountry,
          internationalStatus: settings.international_status,
        },
        loadWidgetRetry: settings.load_widget_retry,
        foreverLoad: settings.forever_load,
        exclude_ids: settings.exclude_ids,
        ProductId: settings.ProductId,
        variants: variantData.variants,
        default_on: window.opAppData.default_on || '1',
        currency_without: window.opAppData.currency_without ,
        currency: window.opAppData.currency ,
        widget_id:window.opAppData.widget_id,
        titles: variantData.titles,
        row_variants: variantData.row_variants,
        row_titles: variantData.row_titles
      };

      this.isInitialized = true;
      opversion = settings.app_version;
      return true;

    } catch (err) {
      console.error("Settings Init Failed:", err);
      if (err.callback) {
        window[err.callback]?.();
      }
      return false;
    }
  },

  loadVariantsFromObject: function (variants, rate) {
    const result = {
      variants: [],
      titles: [],
      row_variants: [],
      row_titles: []
    };

    for (const v of variants) {
      const calculatedName = parseFloat(v.name) * rate;
      const variantEntry = {
        id: v.id,
        name: calculatedName,
        price: v.price
      };

      if (v.sku?.includes("ROW")) {
        result.row_variants.push(variantEntry);
        result.row_titles.push(calculatedName);
      } else {
        result.variants.push(variantEntry);
        result.titles.push(calculatedName);
      }
    }

    return result;
  },

  setVariants: function ({ variants, titles, row_variants, row_titles }, dateString) {
    this.appSettings.variants = variants;
    this.appSettings.titles = titles;
    this.appSettings.row_variants = row_variants;
    this.appSettings.row_titles = row_titles;

    localStorage.setItem('opvariants', JSON.stringify(variants));
    localStorage.setItem('varTitles', JSON.stringify(titles));
    localStorage.setItem('row-opvariants', JSON.stringify(row_variants));
    localStorage.setItem('row-varTitles', JSON.stringify(row_titles));

    if (dateString) {
      localStorage.setItem('op_cache_date', dateString);
      localStorage.setItem('op_cache_timestamp', Date.now().toString());
    }
  },

  getSetting: function (key) {
    return this.appSettings[key];
  },

  getAllSettings: function () {
    return this.appSettings;
  },

  isReady: function () {
    return this.isInitialized;
  }
};

(async function bootstrapSettings() {
  const success = await OrderProtectAppData.SettingsManager.initSettings(opRate, false);
  if (success) {
    opPrint("Settings loaded:", OrderProtectAppData.SettingsManager.getAllSettings());
  } else {
    console.error("Failed to load settings");
  }
})();

// initop the function
const initop = () => {
    startConsole("start"); 
    let checkinit = OrderProtectAppData.SettingsManager.isReady();

    if(checkinit) {
      if(window.opAppData.widget_id > 2) {
        loadWidgetV6();
      }
      runCheckLocalCookie()
      .then(async (cookieResult) => {
        opPrint("Cookie check successful:", cookieResult);
        const opconfig = OrderProtectAppData.SettingsManager.getAllSettings().raw || {};
          return await handleOptInFlow(opconfig);
      })
      .then(()=>{
        getcart();
        startConsole("end"); 
      })
      .catch((err) => {
        opPrint("Initialization or cookie check failed:", err);
        if(err.callback == "cookieZero") {
          // based on widgetID perform action here
          handleCartResetAndDisable();
        }
       startConsole("end"); 
      });
    }
    
  };



  const runCheckLocalCookie = () => {
    return new Promise((resolve, reject) => {
      let cookieval;
      let defaultConsent = 1;
      try {
        const consentSettings = OrderProtectAppData.SettingsManager.getSetting('consentSettings');
        if (consentSettings && consentSettings.switch == 1) {
          defaultConsent = 0;
        }
        const consentVal = localStorage.getItem("opConsentVal") ?? defaultConsent;
        const cookieExists = op_getCookie('opapp');
        const isDefaultOff = window.opAppData.default_on == 0 || window.opAppData.default_on == "0";
        const isConsentZero = consentVal == 0 || consentVal == "0";
        cookieval = (isDefaultOff || isConsentZero) ? (cookieExists || 0) : (cookieExists || 1);
        op_setCookie('opapp', cookieval, '');
        cookieval = op_getCookie('opapp');
        if (cookieval == 0) {
          grayscaleWidget(0, 0);
          return reject({ status: "Cookie is 0", callback: "cookieZero" });
        }
        grayscaleWidget(1, 0);
        resolve({ cookieVal: cookieval });
      } catch (err) {
        reject({ status: "Error occurred", error: err });
      }
    });
  };

const handleOptInFlow = async (opconfig) => {
  try {
    // Set initial UI state
    let insuval = document.querySelectorAll("#insuCheck");
    insuval.forEach((item) => item.setAttribute("checked", "true"));
    disableButtons(opconfig, 1);

    // Add safety timeout to re-enable buttons
    const safetyTimeout = setTimeout(() => {
      opPrint('Safety timeout - force enabling buttons');
      disableButtons(opconfig, 0);
    }, 4000); 

    const {
      CartData,
      cart_variant_id,
      correct_variant_id,
      cartInsItems,
      subtotal_without_op,
      cartInsItemsQuantity,
      ovm
    } = await getFullCartDetails('main', opconfig);

    opPrint("handleOptInFlow", {
      CartData,
      cart_variant_id,
      correct_variant_id,
      cartInsItems,
      subtotal_without_op,
      cartInsItemsQuantity,
      ovm
    });

    setStorage('currentCart', CartData.item_count);

    // Handle recharge items first if any
    const rechargeArray = opconfig.rechargeArray;
    if (Array.isArray(rechargeArray) && rechargeArray.length > 0) {
      await handleRechargeItems(rechargeArray, CartData.items.map(i => i.variant_id));
      // Don't call getcart() here as it might interfere with subsequent operations
    }

    // Check if cart should be empty
    if (ovm === 0 || subtotal_without_op === 0) {
      await emptycart();
      opPrint('Last Item removing cart');
      clearTimeout(safetyTimeout);
      disableButtons(opconfig, 0);
      return;
    }

    // Handle cart protection updates
    if (correct_variant_id) {
      await handleCartProtectionUpdate(
        CartData, 
        correct_variant_id, 
        cartInsItems, 
        cartInsItemsQuantity
      );
    } else {
      opPrint("No correct variant ID found");
    }

    clearTimeout(safetyTimeout);
    disableButtons(opconfig, 0);
    
  } catch (error) {
    opPrint('Error in handleOptInFlow:', error);
    disableButtons(opconfig, 0);
  }
};

async function getFullCartDetails(req, opconfig) {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch /cart.js');
    const CartData = await response.json();
    const CartDataItems = CartData.items || [];
    
    const excludeIds = (opconfig?.exclude_ids || []).map(id => parseInt(id));
    const opItems = CartDataItems.filter(item => item.handle?.includes('order-protect'));
    
    let subtotal_without_op = CartData.total_price;
    let op_total_price = 0;
    let cartInsItemsQuantity = 0;
    let cartInsItems = 0;
    let ovm = CartData.item_count;

    // Calculate cart values without OP items
    for (const item of CartDataItems) {
      const { handle, final_line_price, quantity, url, product_id } = item;
      if (handle?.includes('order-protect')) {
        op_total_price += final_line_price;
        subtotal_without_op -= final_line_price;
        cartInsItemsQuantity += quantity;
        cartInsItems += 1;
        ovm -= quantity;
      } else if (url?.includes('selling_plan') && CartData.rechargeStatus === 0) {
        subtotal_without_op -= final_line_price;
        ovm -= quantity;
      } else if (excludeIds.includes(product_id)) {
        subtotal_without_op -= final_line_price;
        ovm -= quantity;
      }
    }

    // Find correct variant
    const tempcorrect_variant_id = await findLocalVariant(subtotal_without_op);
    opPrint("getFullCartDetails : find_local_variant", tempcorrect_variant_id.res);

    let correct_variant_id = tempcorrect_variant_id.calculated_id;
    let correctCalPrice = tempcorrect_variant_id.calculatedPrice;

    // Find current cart variant
    let cart_variant_id = 0;
    let total_ins_quantity = 0;
    
    for (const item of CartDataItems) {
      const sku = item.sku || '';
      if (sku.includes('ORDERPROTECT') && !sku.includes('SUB')) {
        cart_variant_id = item.variant_id;
        total_ins_quantity = item.quantity;
        break; // Only need the first one
      }
    }

    return {
      CartData,
      cart_variant_id,
      correct_variant_id,
      cartInsItems,
      subtotal_without_op,
      cartInsItemsQuantity,
      ovm,
      correctCalPrice
    };
  } catch (error) {
    opPrint('Error in getFullCartDetails:', error);
    return {
      CartData: {},
      cart_variant_id: 0,
      correct_variant_id: null,
      cartInsItems: 0,
      subtotal_without_op: 0,
      cartInsItemsQuantity: 0,
      ovm: 0,
      correctCalPrice: 0
    };
  }
}
const handleCartProtectionUpdate = async (
  CartData,
  correct_variant_id,
  cartInsItems,
  cartInsItemsQuantity
) => {
  try {
    const opItems = CartData.items.filter(item => 
      item.handle?.includes('order-protect')
    );

    opPrint('DEBUG - Data types:', {
      correct_variant_id: correct_variant_id,
      correct_variant_id_type: typeof correct_variant_id,
      cart_variant_id: opItems[0]?.variant_id,
      cart_variant_id_type: typeof opItems[0]?.variant_id
    });

    // Determine the types and convert accordingly
    let correctVariantToCompare;
    let cartVariantToCompare;
    
    if (typeof correct_variant_id === 'string' && typeof opItems[0]?.variant_id === 'number') {
      // Convert cart variant to string for comparison
      correctVariantToCompare = correct_variant_id;
      cartVariantToCompare = String(opItems[0]?.variant_id);
 
    } else if (typeof correct_variant_id === 'number' && typeof opItems[0]?.variant_id === 'string') {
      // Convert correct variant to string for comparison
      correctVariantToCompare = String(correct_variant_id);
      cartVariantToCompare = opItems[0]?.variant_id;
 
    } else {
      // Same type or unknown - use as is
      correctVariantToCompare = correct_variant_id;
      cartVariantToCompare = opItems[0]?.variant_id;
     }

    // Find the correct OP item with proper type handling
    const correctOpItem = opItems.find(item => {
      const itemVariantId = typeof item.variant_id === 'number' ? String(item.variant_id) : item.variant_id;
      const correctVariantId = typeof correct_variant_id === 'number' ? String(correct_variant_id) : correct_variant_id;
      return itemVariantId === correctVariantId && item.quantity === 1;
    });

    if (correctOpItem && opItems.length === 1) {
      opPrint('Correct OP item already in cart with correct quantity - skipping update');
      return;
    }

    // Remove all existing OP items if we have any
    if (opItems.length > 0) {
      opPrint(`Removing ${opItems.length} existing OP items`);
      const removalPromises = opItems.map(item => 
        addRemoveItem(item.key, 0, 'delete')
      );
      await Promise.all(removalPromises);
      
      await new Promise(resolve => setTimeout(resolve, 500));
    }

    // Add correct OP item
    opPrint(`Adding correct OP variant: ${correct_variant_id}`);
    await addRemoveItem(correct_variant_id, 1, 'add');
    
    opPrint('Cart protection update completed successfully');

  } catch (error) {
    opPrint('Error in handleCartProtectionUpdate:', error);
    throw error;
  }
};


  const logCartDetails = (cartBreakdown, localVariantId, calltoupdate, itemCount) => {
    opPrint(`Cart Item Count: ${itemCount}`);
    opPrint(`Cart Variant ID: ${cartBreakdown.cart_variant_id}`);
    opPrint(`Local Variant ID: ${localVariantId}`);
    opPrint(`Multiples: ${cartBreakdown.multiple}`);
    opPrint(`Protection Quantity: ${cartBreakdown.total_ins_quantity}`);
    opPrint(`Update Cart Call Result: ${calltoupdate}`);
  };



  document.addEventListener('DOMContentLoaded', (event) => {
    initop();
  });



























function cookiecheck(checkboxElem) {
  let opc = document.querySelectorAll("#opc");
  let insuCheck = document.querySelectorAll("#insuCheck");
  insuCheck.forEach((item) => item.disabled = false);
  checkboxElem.checked ? opc.forEach((item) => item.classList.remove("grayscale")) : opc.forEach((item) => item.classList.add("grayscale"));
  if (checkboxElem.checked) {
    grayscaleWidget(1, 0);
    op_setCookie('opapp', 1, '');
    initop();
  } else {
    op_setCookie('opapp', 0, '');
    grayscaleWidget(0, 0);
    emptycart();
    getcart();
  }
}
const grayscaleWidget = async (status, grayscale) => {
  let opc = document.querySelectorAll("#opc");
  let optxton = document.querySelectorAll('#opinsuon');
  let optxtoff = document.querySelectorAll('#opinsuoff');
  if (status == 1) {
    optxton.forEach((item) => item.style.display = "contents");
    optxtoff.forEach((item) => item.style.display = "none");
    if (grayscale == 1) {
      opc.forEach((item) => item.classList.remove("grayscale"));
    }
  }
  else {
    optxton.forEach((item) => item.style.display = "none");
    optxtoff.forEach((item) => item.style.display = "contents");
    if (grayscale == 1) {
      opc.forEach((item) => item.classList.add("grayscale"));
    }
  }
};
function op_getCookie(e) { let t = e + "=", n = decodeURIComponent(document.cookie).split(";"); for (let e = 0; e < n.length; e++) { let o = n[e]; for (; " " == o.charAt(0);)o = o.substring(1); if (0 == o.indexOf(t)) return res = o.substring(t.length, o.length), res } return "" }
function op_setCookie(cname, cvalue, exdays) { document.cookie = cname + "=" + cvalue + ";";  return cname + "=" + cvalue + ";" }
function op_deleteCookie(cname){document.cookie = cname+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";}
function setStorage(name, data) { localStorage.setItem(name, JSON.stringify(data)); }
function deleteStorage(name) { localStorage.removeItem(name); }
function getStorage(name) { return JSON.parse(localStorage.getItem(name)); }
function startConsole(method) {
 let debug = op_getCookie('OpDebug') ? op_getCookie('OpDebug') : 0;
  if(debug==1){
  if (method === "start") {
    console.group("Order Protect");
  } else if (method === "end") {
    console.groupEnd();
  }
}
}
function opPrint(fn,log) {
  let debug = op_getCookie('OpDebug') ? op_getCookie('OpDebug') : 0;
  if(debug==1){
    let returnString = {
      function:fn,
      log:log
    }
  console.log(returnString);
  }
}

opShopify.formatMoney = function (cents, format = window.opAppData.currency_without) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = ''; var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/; var formatString = format || this.money_format;
  function defaultOption(opt, def) { return typeof opt == 'undefined' ? def : opt; }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2); thousands = defaultOption(thousands, ','); decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      ),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
  }
  return formatString.replace(placeholderRegex, value);
};
let renderSubAmount = (CartDataSubtotal,subt_id) => {
  if (subt_id) {
    subt_id.forEach((item) => {
      item.innerHTML = opShopify.formatMoney(CartDataSubtotal, window.opAppData.currency_without);
    });
  }
};

function resetCart() {
  // Remove all opCheckout elements and their previous sibling if it has class opwidget
  document.querySelectorAll(".opCheckout").forEach(el => {
if (el.previousElementSibling && el.previousElementSibling.id === "opc") {
  el.previousElementSibling.remove();
}
     
    el.remove();
  });

  // Preserve existing config logic
  const opconfig = OrderProtectAppData.SettingsManager.getAllSettings().raw || {};
  const DEFAULT_SECOND_POP_SELECTOR = 'button[name="checkout"]';
  const secondPopSelector = fixSelector(opconfig.swloc_selector) || DEFAULT_SECOND_POP_SELECTOR;

  // Force display:block on *all* matches
  document.querySelectorAll(secondPopSelector).forEach(btn => {
    btn.style.display = "flex";
  });

  return secondPopSelector;
}







  const emptycart = async (callback) => {
    try {
      const CartData = await fetch('/cart.js').then(res => res.json());
      const items = CartData.items;
      const promises = [];
      for (const item of items) {
        if (item.handle.includes('order-protect')) {
          promises.push(addRemoveItem(item.variant_id, 0, 'delete'));
        }
      }
      if (promises.length > 0) {
        await Promise.all(promises);
      }
      if (callback) callback();
    } catch (err) {
      opPrint("Error in emptycart:", err);
    }
  };

  function handleCartResetAndDisable(opconfig = {}) {
    opPrint("Need to clear the cart and disable");
    // Initialize widget loaders
    initOpWidgetLoaders(opconfig);
    // Apply grayscale effect and clear cart
    grayscaleWidget(0, 0);
    emptycart();
    // Remove animation class if present
    const hascart = document.querySelectorAll('#insurance_text');
    if (hascart.length > 0) {
      hascart.forEach(item => {
        if (item) {
          item.classList.remove("dot-collision");
        }
      });
    }
  }

let disableButtons = (e, t) => {
  // opPrint("Disable " + t);
  // STRONG safe fallback
  let checkoutSelector = '[name="checkout"]';
  if (e && typeof e.checkout_selector === 'string') {
      let trimmed = e.checkout_selector.trim();
      if (trimmed !== "" && trimmed !== "null") {
          checkoutSelector = trimmed;
      }
  }

  let checkoutButtons = [];
  try {
      checkoutButtons = document.querySelectorAll(checkoutSelector);
  } catch (err) {
     opPrint("Invalid checkoutSelector for querySelectorAll:", checkoutSelector, err);
  }
  let config = null;
  try {
      config = JSON.parse(localStorage.getItem("selectorConfig"));
  } catch (err) {
     opPrint("Invalid selectorConfig in localStorage", err);
  }
  let clickTriggers = config?.clicktriggers;
  let triggerSelector = "";
  if (clickTriggers) {
      triggerSelector = Array.isArray(clickTriggers) ? clickTriggers.join(",") : clickTriggers.toString();
  }
  if (triggerSelector.trim() !== "") {
      try {
          document.querySelectorAll(triggerSelector).forEach(btn => {
              t === 1 ? btn.disabled = true : btn.removeAttribute("disabled");
          });
      } catch (err) {
         opPrint("Invalid clickTrigger selector:", triggerSelector, err);
      }
  }
  checkoutButtons.forEach(btn => {
      t === 1 ? btn.disabled = true : btn.removeAttribute("disabled");
  });
};

async function getRemoveItemKeys(opconfig) {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch /cart.js');
    const CartData = await response.json();
    const CartDataItems = CartData.items || [];
    const excludeIds = (opconfig?.exclude_ids || []).map(id => parseInt(id));
    const opItems = CartDataItems.filter(item => item.handle?.includes('order-protect'));
    let remove_item_keys = [];
    // Process each item in the cart
    for (const item of CartDataItems) {
      const { handle, product_id, variant_id } = item;
      if (handle?.includes('order-protect')) { 
        const tempcorrect_variant_id = await findLocalVariant(CartData.total_price);// Get the correct variant ID
        opPrint("getRemoveItemKeys : find_local_variant", tempcorrect_variant_id.res);
        
        let correct_variant_id = tempcorrect_variant_id.calculated_id;
        if (item.variant_id !== correct_variant_id) {
          remove_item_keys.push(item.key); // Store the line item key to remove
        }
      } else if (excludeIds.includes(product_id)) {
        // If the product should be excluded from the cart
        remove_item_keys.push(item.key);
      }
    }
    return remove_item_keys;
  } catch (error) {
    opPrint('Error in getRemoveItemKeys:', error);
    return [];
  }
}

  /************************************************ */
  /***************** Getcart ********************** */
  /************************************************ */
  const fixSelector = (selector) => {
    if (Array.isArray(selector)) selector = selector[0] || '';
    if (typeof selector !== 'string') selector = '';
    selector = selector.trim();
    if (!selector || selector === 'null') selector = '';
    return selector;
  };
  const addRemoveItem = (itemId, quantity, method, callback) => {
    const dData = { id: itemId.toString(), quantity: quantity };
    if (method === 'delete') {
      return fetch(window.opShopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dData)
      }).then(res => {
        opPrint("item deleted" , res);
        if (callback) callback();
      });
    }
    if (method === 'add') {
      return fetch(window.opShopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dData)
      }).then(res => {
        opPrint("item added");
        if (callback) callback();
      });
    }
  };
  const cartbreakdown = async () => {
    const CartData = await fetch('/cart.js').then(res => {
      if (!res.ok) throw new Error('Failed to fetch cart.js');
      return res.json();
    });
    const opconfig = OrderProtectAppData.SettingsManager.getAllSettings().raw || {};
    const excludeIds = opconfig.exclude_ids || [];
    const opItems = CartData.items.filter(item => item.handle && item.handle.includes('order-protect'));
    let only_one_op = null;
    let multiple_op_variant_ids = [];
    let subtotal_without_op = CartData.total_price;
    let op_total_price = 0;
    let remove_item_keys = [];
    let cartInsItemsQuantity = 0; 
    let cartInsItems = 0;
    let ovm = CartData.item_count;
    let finalnumber = 0;
    for (const item of CartData.items) {
      if (item.handle && item.handle.includes('order-protect')) {
        op_total_price += item.final_line_price;
        subtotal_without_op -= item.final_line_price;
        cartInsItemsQuantity += item.quantity;
        cartInsItems += 1;
        ovm -= item.quantity;
        multiple_op_variant_ids.push(item.variant_id);
      } else if (item.url.includes('selling_plan') && CartData.rechargeStatus === 0) {
        subtotal_without_op -= item.final_line_price;
        ovm -= item.quantity;
      } else {
        if (excludeIds.length > 0) {
          excludeIds.forEach(id => {
            if (item.product_id === parseInt(id)) {
              subtotal_without_op -= item.final_line_price;
              ovm -= item.quantity;
              finalnumber += item.quantity;
            }
          });
        }
      }
    }

    

    if (opItems.length === 1 && opItems[0].quantity === 1) {
      only_one_op = opItems[0];
    }
    const tempcorrect_variant_id = await findLocalVariant(subtotal_without_op);
    opPrint("cartbreakdown : find_local_variant", tempcorrect_variant_id.res);
    let correct_variant_id = tempcorrect_variant_id.calculated_id;
    let correctCalPrice = tempcorrect_variant_id.calculatedPrice;
    for (const item of opItems) {
      if (item.variant_id !== correct_variant_id) {
        remove_item_keys.push(item.variant_id);
      }
    }

      const has_correct_op = opItems.some(item => item.variant_id === correct_variant_id);

    return {
      CartData,
      only_one_op,
      correctCalPrice,
      multiple_op_variant_ids,
      subtotal_without_op,
      op_total_price,
      correct_variant_id,
      remove_item_keys,
      cartInsItems,
      cartInsItemsQuantity,
      ovm,
      has_correct_op,
      finalnumber
    };
  };
  

function findClosest(goal, quantities) {
  let closestUpper = null;
  let minDiff = Infinity;
  
  for (const qty of quantities) {

    if (qty >= goal) {
      const diff = qty - goal;
      if (diff < minDiff) {
        minDiff = diff;
        closestUpper = qty;
      }
    }
  }
 
  if (closestUpper === null) {
    return Math.max(...quantities);
  }
  
  return closestUpper;
}

const findLocalVariant = async (ct) => {
  try {
    if (typeof ct !== 'number' || isNaN(ct)) {
      opPrint("Invalid input to find_local_variant: ct must be a valid number", ct);
      return null;
    }
    const homeCountry = localStorage.getItem('homeCountry') || "0";
    const customerCountry = localStorage.getItem('currentcountry');
    let settingv = [];
    let storedvt = [];
    const parseStoredTitles = (key) => {
      try {
        const raw = localStorage.getItem(key);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed)
          ? parsed.filter(n => typeof n === 'number' && !isNaN(n))
          : [];
      } catch (e) {
        opPrint(`Error parsing ${key}:`, e);
        return [];
      }
    };
    if (homeCountry !== "0") {
      const allowedCountries = homeCountry.split(",");
      const isHome = allowedCountries.includes(customerCountry);
      if (isHome) {
        settingv = JSON.parse(localStorage.getItem('opvariants') || '[]');
        storedvt = parseStoredTitles('varTitles');
        // opPrint("find_local_variant", "FLV if - home", settingv);
      } else {
        settingv = JSON.parse(localStorage.getItem('row-opvariants') || '[]');
        storedvt = parseStoredTitles('row-varTitles');
        // opPrint("find_local_variant", "FLV if - row", settingv);
      }
    } else {
      settingv = JSON.parse(localStorage.getItem('opvariants') || '[]');
      storedvt = parseStoredTitles('varTitles');
      // opPrint("find_local_variant", "FLV else", settingv);
    }
    const goal = ct / 100;
    let calculated_id = null;
    let calculatedPrice = 0;
   
    const counts = [...new Set(storedvt)].sort((a, b) => b - a);
    if (counts.length === 0) {
      opPrint("find_local_variant", "No valid variant titles found.");
      return null;
    }
    // const closest = counts.find(c => c >= goal) ?? counts[counts.length - 1];
 
    const closest = findClosest(goal, storedvt);  

    for (const variant of settingv) {
      if (parseFloat(variant.name) === closest) {
        calculated_id = variant.id;
        calculatedPrice = variant.price;
        break;
      }
    }
    const trace = {
      homeCountry,
      customerCountry,
      calculated_id,
      goal,
      closest,
      counts,
      storedvt,
      settingv,
      calculatedPrice
    };
    return {
        calculated_id,
        calculatedPrice,
        res:trace
    };
  } catch (error) {
    opPrint("Error in find_local_variant:", error);
    return null;
  }
};

function initOpWidgetLoaders(opconfig = {}) {
  const DEFAULT_SECOND_POP_SELECTOR = 'button[name="checkout"]';
  let loadWidgetRetry = 3;
  try {
    const parsedRetry = JSON.parse(opconfig.loadWidgetRetry);
    if (typeof parsedRetry === "number" && !isNaN(parsedRetry)) {
      loadWidgetRetry = parsedRetry;
    }
  } catch (e) {}
  const wlocSelector = fixSelector(opconfig.wloc_selector);
  if (wlocSelector) load_widget(wlocSelector, loadWidgetRetry);
  const secondPopSelector = fixSelector(opconfig.swloc_selector) || DEFAULT_SECOND_POP_SELECTOR;

  if (secondPopSelector) injectOpCheckoutButtons(secondPopSelector, loadWidgetRetry);
}



const injectOpCheckoutButtons = (selector = '.checkout-class') => {
const checkoutButtons = document.querySelectorAll(selector);
let opCheckoutMissing = false;
checkoutButtons.forEach((button) => {
 
   if(window.opAppData.widget_id > 2) {
    button.style.display = "none";
   }
   const parent = button?.parentNode;
    if (parent && !parent.querySelector('.opCheckout')) {
      const opCheckoutElement = document.createElement('div');
      opCheckoutElement.classList.add('opCheckout');
      parent.insertBefore(opCheckoutElement, button); 
      opCheckoutMissing = true;
    }
});
if (opCheckoutMissing) {
  load_widget('.opCheckout', 3);
}
};
const load_widget = async (selector, r) => {
  // Make sure selector is a valid, non-empty string
  if (typeof selector !== 'string' || selector.trim() === '') {
    opPrint('Invalid or empty selector provided to load_widget:', selector);
    return;
  }
  opPrint('load_widget ' + selector + ' retry ' + r);
  r -= 1;
  let widget_con = [];
  try {
    widget_con = document.querySelectorAll(selector);
  } catch (err) {
    opPrint('Error while running querySelectorAll with selector:', selector, err);
    return;
  }
  if (widget_con.length > 0) {
    const opc = document.querySelector('#opc');
    if (!opc) {
      opPrint('Could not find #opc element to clone.');
      return;
    }
  
    const widget_itm = opc.cloneNode(true);
    widget_itm.style.visibility = 'visible';
    widget_itm.style.display = 'flex';
    
    widget_con.forEach((item) => {
     
    if (item.parentNode.innerHTML.includes("opwidget")) {
      // do nothing
    } else {
      
        item.parentNode.insertBefore(widget_itm, item);
    }
    });

    return;
  } else {
    if (r > 0) {
      setTimeout(() => load_widget(selector, r), 1000);
    }
  }
};


async function foreverLoader(totalRuns = 100) {
  for (let i = 0; i < totalRuns; i++) {
    const opconfig = OrderProtectAppData.SettingsManager.getAllSettings().raw || {};
    initOpWidgetLoaders(opconfig);

    opPrint("foreverLoader", i);
    // choose delay based on iteration
    const delay = i < 10 ? 3000 : 5000;

    if (i < totalRuns - 1) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
}


  const getcart = (callback) => {
    // const cookieval = typeof op_getCookie('opapp') === 'string' ? op_getCookie('opapp') : '1';
    const opconfig = OrderProtectAppData.SettingsManager.getAllSettings().raw || {};
    // initOpWidgetLoaders(opconfig);
    setTimeout(async () => {
      const subtotalSelector = fixSelector(opconfig.subtotal_selector);
      const subtId = subtotalSelector ? document.querySelectorAll(subtotalSelector) : [];
      const minicartSelector = fixSelector(opconfig.minicart_selector);
      const minicart = minicartSelector ? document.querySelectorAll(minicartSelector) : [];
      const {
        CartData,
        only_one_op,
        multiple_op_variant_ids,
        subtotal_without_op,
        op_total_price,
        correct_variant_id,
        remove_item_keys,
        cartInsItems,
        cartInsItemsQuantity,
        ovm,
        correctCalPrice,
        finalnumber
      } = await cartbreakdown();

   const foundCorrectVariant = CartData.items.some(item => String(item.variant_id) === correct_variant_id);

    opPrint('Order Protect Debug Info:',{foundCorrectVariant,correctCalPrice,CartData,only_one_op,multiple_op_variant_ids,subtotal_without_op,op_total_price,correct_variant_id,remove_item_keys,'ovi (Order Protect Item Total Quantity)':`${cartInsItems}-${cartInsItemsQuantity}`,'ovm (MiniCart Item Count)':ovm});
    
      if (cartInsItems != cartInsItemsQuantity && cartInsItems < cartInsItemsQuantity) {
        const orderProtectItems = CartData.items.filter(item => item.handle && item.handle.includes('order-protect'));
        for (const item of orderProtectItems) {
          if (item.variant_id === correct_variant_id && item.quantity > 1) {
            opPrint(item);
            opPrint(`Reducing quantity of correct OP variant ${item.variant_id} from ${item.quantity} to 1wit key ${item.key}`);
            await addRemoveItem(item.key.toString(), 1, 'delete');
          }
        }
      }
      if (CartData.items_subtotal_price === 0) {
        removewidget();
        return;
      }
      const hascart = document.querySelectorAll('#insurance_text');

        if (hascart.length > 0 && op_total_price !== 0 ) {
        hascart.forEach(item => {

        if (item) {
          item.classList.remove("dot-collision");
          if (ovm == 0) {
          item.innerHTML = '';
          }
          else{
          item.innerHTML = opShopify.formatMoney(correctCalPrice, window.opAppData.currency_without);
          }
        }
        });
      }
      if (minicart.length > 0) {
        minicart.forEach(item => {
          item.innerHTML = ovm + finalnumber;
        });
      }
     renderSubAmount(CartData.total_price, subtId);
      const widcl = document.querySelectorAll('#opc');
      widcl.forEach(item => {
        if (item) item.style.display = "block";
      });
      if (typeof cu_op_fn === 'function') cu_op_fn();
      if (callback) setTimeout(() => callback(), 100);
    }, 0);
  };


let removewidget = () => {
  let widcl = document.querySelectorAll('#opc');
  if(widcl) widcl.forEach((item) => item ? item.style.display = "none" : null);
};
  /*********************************** */
  /*********************************** */
  /*********************************** */

document.addEventListener('DOMContentLoaded', () => {
  const selectorConfig = OrderProtectAppData.SettingsManager.getSetting('selectors') || {}; 
  const foreverLoadVal = Number(selectorConfig?.foreverLoad || 0);
   
  if (foreverLoadVal !== 0) {
     foreverLoader(foreverLoadVal);
  }
  opPrint("DOMContentLoaded", selectorConfig);
  const clicktriggers = Array.isArray(selectorConfig.clicktriggers) ? selectorConfig.clicktriggers : [];
  const changetriggers = Array.isArray(selectorConfig.changetriggers) ? selectorConfig.changetriggers : [];

  opCheckConsent();
  
  // CLICK HANDLER
  document.addEventListener('click', function (e) {
    const target = e.target;
    let matched = false;
    if (!(target instanceof Element)) return;
    const addBtn = target.closest('button[name="add"], [data-add-to-cart], .add-to-cart, [id*="AddToCart"], [class*="add-to-cart"]');
    if (addBtn) {
      opPrint('EventClick',`Add to cart button clicked: ${addBtn}`);
      matched = true;
    }
    clicktriggers.forEach(selector => {
      const individualSelectors = selector.split(',').map(s => s.trim()).filter(Boolean);
      for (const sel of individualSelectors) {
        try {
          if (target.closest(sel)) {
           opPrint('EventClick',`Click trigger matched: ${sel}`);
            matched = true;
            break;
          }
        } catch (err) {
          opPrint(`Invalid click selector: ${sel}`, err);
        }
      }
    });
    if (matched) {
      setTimeout(() => callupdatefunction(0), 500);
    }
  });
  // CHANGE HANDLER
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;
    const input = target.closest('input[name="updates[]"]');
    let matched = !!input;
    changetriggers.forEach(selector => {
      const individualSelectors = selector.split(',').map(s => s.trim()).filter(Boolean);
      for (const sel of individualSelectors) {
        try {
          if (target.closest(sel)) { 
            matched = true;
            break;
          }
        } catch (err) {
          opPrint(`Invalid change selector: ${sel}`, err);
        }
      }
    });
    if (matched) {
      setTimeout(() => callupdatefunction(0), 1000);
    }
  });
});
/*********************************************************************/
/*********************************************************************/
/*********************************************************************/
function closeConsent() {
  const element = document.querySelector(".op_consent");
  if (element) {
      element.style.display = "none";
  }
}
function opConsentSave(val) {
  localStorage.setItem("opConsentVal", val);
  // Optional verification
  const opConsentVal = localStorage.getItem("opConsentVal");
  opPrint("opConsentSave", opConsentVal);
  closeConsent();
}
function showConsentForm(timeout = 1000) {
  const element = document.querySelector(".op_consent ");
  if (element) {
      setTimeout(() => {
          element.style.display = "flex";
      }, timeout);
  }
}
async function opCheckConsent() {
  let consentVal = localStorage.getItem("opConsentVal") || null;
  try {
      const statusConsentVar = OrderProtectAppData.SettingsManager.getSetting('consentSettings');
      if (statusConsentVar && parseInt(statusConsentVar.switch) === 1) {
          if (consentVal === null) {
              // opPrint("opCheckConsent", "Consent not found in localStorage. Showing consent form.");
              showConsentForm();
          } else {
              // opPrint("opCheckConsent", "Consent already provided.");
          }
      } else {
          // opPrint("opCheckConsent", "Consent feature disabled via settings.");
      }
  } catch (error) {
      opPrint("Error fetching consent settings:", error);
  }
  return consentVal;
}
/****************consent end****************** */
function callupdatefunction(retry = 0) {
  callGetCart()
    .then(cartData => {
      retry += 1;
      let currentCart = parseInt(localStorage.getItem('currentCart')) || 0;
      opPrint("callupdatefunction", `Current cart: ${cartData.item_count} | Stored cart: ${currentCart} | Retry: ${retry}`);
      if (cartData.item_count !== currentCart) {
        localStorage.setItem('currentCart', cartData.item_count);
        initop();
      } else if (retry < 10) {
        setTimeout(() => callupdatefunction(retry), 1000);
      }
    })
    .catch(err => opPrint("Error in callupdatefunction:", err));
}
let callGetCart = () => {
  return new Promise(function(myResolve, myReject) {
    fetch('/cart.js')
      .then(res => myResolve(res.json()))
  });
}
let opSetCountry = () => {
  return new Promise(function(myResolve, myReject) {
 fetch('https://ipapi.co/json/') // You can replace with any other geolocation API
 .then((response) => response.json())
 .then((data) => {
   opPrint("opSetCountry",data);
    myResolve({con:data.country});
 })
 .catch((error) => {
   opPrint('Error fetching IP geolocation data:', error);
 });
});
}              
let opLoadCountry = () => {
 let checkstoredlocation;
 if(localStorage.getItem("currentcountry")){
     checkstoredlocation = localStorage.getItem("currentcountry");
     return checkstoredlocation;
 }
 else 
 {
   opSetCountry()
     .then(res=>{
               checkstoredlocation = res.con;
               localStorage.setItem("currentcountry",checkstoredlocation);
               return checkstoredlocation;
                       });
 }
};

 
 
function setContentAll(selector, content) {
  const elements = document.querySelectorAll(selector);

  if (!elements.length) {
    opPrint(`No elements found for selector: ${selector}`);
    return;
  }

  elements.forEach(el => {
    el.innerHTML = content;
  });
}

function updateVariantIdAll(newVariantId) {
  const buttons = document.querySelectorAll(".addOp");

  if (!buttons.length) {
    opPrint("No buttons found with .addOp");
    return;
  }

  buttons.forEach(btn => {
    btn.setAttribute("variant_id", newVariantId);
  });
}

const opAddRemoveItem = async (itemId, quantity, method, callback) => {
  const dData = { id: itemId.toString(), quantity: quantity };

  let endpoint = "";
  if (method === "delete") {
    endpoint = "cart/change.js";
  } else if (method === "add") {
    endpoint = "cart/add.js";
  } else {
    throw new Error("Invalid method for opAddRemoveItem");
  }

  const res = await fetch(window.opShopify.routes.root + endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dData),
  });

  if (!res.ok) {
    throw new Error(`Failed request: ${res.status}`);
  }

  const data = await res.json();

  if (callback) callback(data);

  return data; // parsed Shopify response
};

 


async function loadWidgetV6 (){

const opconfig = OrderProtectAppData.SettingsManager.getAllSettings().raw || {};
initOpWidgetLoaders(opconfig);


const {
subtotal_without_op,
correct_variant_id,
correctCalPrice
} = await cartbreakdown();

let newtotal = (parseFloat(correctCalPrice) * 100 ) + parseFloat(subtotal_without_op);

opPrint(correctCalPrice + '  ' +subtotal_without_op );

setContentAll('.opCalSubtotal',opShopify.formatMoney(newtotal, window.opAppData.currency_without) );
setContentAll('#insurance_text', opShopify.formatMoney(correctCalPrice, window.opAppData.currency_without) );
updateVariantIdAll(correct_variant_id);
const hascart = document.querySelectorAll('#insurance_text');
  if (hascart.length > 0 ) {
    hascart.forEach(item => {
      if (item) {
        item.classList.remove("dot-collision");
      }
    });
  }
opPrint("loadSettingForV6",{correctCalPrice,correct_variant_id})
return;
}




document.addEventListener("click", function (e) {
  const btn = e.target.closest(".addOp, .removeOp");
  if (!btn) return;

  e.preventDefault();
  if (btn.disabled) return; // already processing

  btn.disabled = true;
  btn.classList.add("op-disabled");

  const variantId = btn.getAttribute("variant_id");

  if (btn.classList.contains("addOp")) {
    // --- ADD OP: swap icon with spinner ---
    const iconEl = btn.querySelector("svg");
    if (iconEl) {
      btn.dataset.originalIcon = iconEl.outerHTML;
      iconEl.outerHTML = `<span class="op-spinner"></span>`;
    }

    Promise.resolve(addOp(variantId))
      .finally(() => {
        btn.disabled = false;
        btn.classList.remove("op-disabled");

        // Restore SVG
        const spinner = btn.querySelector(".op-spinner");
        if (spinner && btn.dataset.originalIcon) {
          spinner.outerHTML = btn.dataset.originalIcon;
        }
      });

  } else if (btn.classList.contains("removeOp")) {
    // --- REMOVE OP: just disable, no spinner ---
    Promise.resolve(removeOp(variantId))
      .finally(() => {
        btn.disabled = false;
        btn.classList.remove("op-disabled");
      });
  }
});


async function addOp() { 

  try { 
      op_setCookie('opapp', 1, '');

    // 2. Get cart breakdown
    const {
        CartData,
        only_one_op,
        multiple_op_variant_ids,
        subtotal_without_op,
        op_total_price,
        correct_variant_id,
        remove_item_keys,
        cartInsItems,
        cartInsItemsQuantity,
        ovm,has_correct_op,
        correctCalPrice
      } = await cartbreakdown();

    opPrint("Cart breakdown:", {
        CartData,
        only_one_op,
        multiple_op_variant_ids,
        subtotal_without_op,
        op_total_price,
        correct_variant_id,
        remove_item_keys,
        cartInsItems,
        cartInsItemsQuantity,
        ovm,
        correctCalPrice,
        has_correct_op
      });

      if (remove_item_keys.length > 0) {
        const removalPromises = remove_item_keys.map(key => addRemoveItem(key, 0, 'delete'));
        await Promise.all(removalPromises); // Execute all removals concurrently
      }

   
      if(has_correct_op) {
       opPrint("variant allready added");
           window.location.href = "/checkout";
              return;
      }
      else
        {
            if (correct_variant_id) {
            let result = await opAddRemoveItem(correct_variant_id, 1, "add");

           opPrint("Add-to-cart result:", result);

            if (result && result.id) {
             opPrint(" Variant added:", correct_variant_id);

              // Redirect to checkout
              window.location.href = "/checkout";
              return;
            }
          }
      }
  } catch (err) {
     console.error("Error in opAddHandler:", err);
      await emptycart();
      window.location.href = "/checkout";
  }
}
 

async function removeOp (){
  op_setCookie('opapp', 0, '');
  await emptycart();
  window.location.href = "/checkout";
}